<script>
  import MessengerShell from './layout/MessengerShell.svelte';
</script>

<MessengerShell />
